import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { TabPanel } from '@mui/lab';
import { RecursiveGraphQueryTemplate } from '../RecursiveGraphQueryTemplate';
export const RecursiveGraphQuery = ({ value }) => {
    return (_jsx(TabPanel, { value, children: _jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "3. Node Edge Mapper Results for a BranchingGraphQuery" }), _jsx(RecursiveGraphQueryTemplate, {}, 'a')] }) }, 'tableQueryFilter'));
};
